export default function deb (func, wait = 0, immediate) {
  let timeout;
  return function retfun (...args) {
    const context = this;

    const later = function lat () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
